import React, { useState, useEffect } from 'react';
import { tradingAPI } from '../../services/api';
import { TRADING_COLORS as C } from './constants';

const OrderBook = ({ symbol, compact = false }) => {
  const [data, setData] = useState({ bids: [], asks: [] });

  useEffect(() => {
    const load = () => tradingAPI.getOrderBook(symbol, 12).then(r => setData(r.data || { bids: [], asks: [] }));
    load();
    const interval = setInterval(load, 2000);
    return () => clearInterval(interval);
  }, [symbol]);

  const asks = data.asks.slice(0, 12).reverse();
  const bids = data.bids.slice(0, 12);
  
  const maxVol = Math.max(
    ...asks.map(a => a[1] || 0), 
    ...bids.map(b => b[1] || 0), 
    1
  );
  
  const midPrice = data.bids[0]?.[0] || 0;
  const totalBids = bids.reduce((s, b) => s + (b[1] || 0), 0);
  const totalAsks = asks.reduce((s, a) => s + (a[1] || 0), 0);
  const buyRatio = totalBids + totalAsks > 0 ? Math.round((totalBids / (totalBids + totalAsks)) * 100) : 50;

  const fmtPrice = (p) => {
    const n = parseFloat(p);
    return n >= 1000 ? n.toFixed(2) : n >= 1 ? n.toFixed(2) : n.toFixed(4);
  };

  const fmtSize = (s) => {
    const n = parseFloat(s);
    return n >= 1 ? n.toFixed(2) : n >= 0.01 ? n.toFixed(3) : n.toFixed(4);
  };

  const Row = ({ price, size, type }) => {
    const pct = Math.min((size / maxVol) * 100, 100);
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        padding: '2px 0', 
        position: 'relative',
        fontSize: 10,
        fontFamily: 'monospace',
      }}>
        <div style={{ 
          position: 'absolute', 
          right: 0, top: 0, bottom: 0, 
          width: `${pct}%`, 
          background: type === 'ask' ? 'rgba(246,70,93,0.12)' : 'rgba(14,203,129,0.12)',
        }} />
        <span style={{ color: type === 'ask' ? C.short : C.long, zIndex: 1, fontWeight: 500 }}>
          {fmtPrice(price)}
        </span>
        <span style={{ color: C.textSecondary, zIndex: 1 }}>
          {fmtSize(size)}
        </span>
      </div>
    );
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', color: C.textTertiary, fontSize: 9, paddingBottom: 3, borderBottom: `1px solid ${C.border}` }}>
        <span>Цена</span><span>Кол-во</span>
      </div>
      
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', paddingTop: 4 }}>
        {asks.map((a, i) => <Row key={`a${i}`} price={a[0]} size={a[1]} type="ask" />)}
      </div>
      
      <div style={{ padding: '6px 0', borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`, margin: '3px 0' }}>
        <span style={{ color: C.long, fontSize: 12, fontWeight: 700, fontFamily: 'monospace' }}>
          {fmtPrice(midPrice)}
        </span>
      </div>
      
      <div style={{ flex: 1, paddingBottom: 4 }}>
        {bids.map((b, i) => <Row key={`b${i}`} price={b[0]} size={b[1]} type="bid" />)}
      </div>
      
      <div style={{ paddingTop: 4, borderTop: `1px solid ${C.border}` }}>
        <div style={{ display: 'flex', gap: 1 }}>
          <div style={{ flex: buyRatio, height: 3, background: C.long, borderRadius: 1 }} />
          <div style={{ flex: 100 - buyRatio, height: 3, background: C.short, borderRadius: 1 }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 9, marginTop: 2 }}>
          <span style={{ color: C.long }}>B {buyRatio}%</span>
          <span style={{ color: C.short }}>{100 - buyRatio}% S</span>
        </div>
      </div>
    </div>
  );
};

export default OrderBook;
